<template>
<!-- b-${$route.name == 'login' ? '50' : '20'} -->
  <button
    @click="showHelpButton"
    v-if="$store.state.app.activeGroup.id == 9265"
    :class="`
        pos-fixed
        b-60
        r-20
        text-uppercase
        btn btn-lg btn-warning btn-icon
        rounded-pill
      `"
  >
    <feather type="help-circle" class="ht-20-f wd-20-f"></feather>
  </button>
</template>


<script>
import { Notification } from "element-ui";

export default {
  name: "helpNotif",
  components: {
    Notification,
  },
  data: () => ({}),
  methods: {
    showHelpButton() {
      Notification.warning({
        message:
          "Тусламж хэрэгтэй бол online@bfa.mn мэйл хаягаар хүсэлтээ илгээнэ үү.",
        title: "Тусламж",
        duration: 30000,
        type: "info",
        position: "bottom-right",
        offset: 90,
      });
    },
  },
};
</script>
